export const PERMISSION_MESSAGE = "Sorry, you don't have permission to access this page";

export const CERTIFICATION_PENDING_MESSAGE =
  "This page unlocks once your company's certification is approved. Head back to the dashboard to finish your certification.";
